import { socket } from '../core/socket.js';
import { state } from '../core/state.js';
import { t } from '../core/i18n.js';
import { popToast, chaosNotify } from '../utils/alerts.js';

export const PERMISSIONS_DEF = [
    { categorie: 'modal.roles.cat_general', perms: [
        { key: 'voir_salons',    label: 'modal.roles.perm_voir_salons' },
        { key: 'gerer_salons',   label: 'modal.roles.perm_gerer_salons' },
        { key: 'gerer_roles',    label: 'modal.roles.perm_gerer_roles' },
        { key: 'gerer_serveur',  label: 'modal.roles.perm_gerer_serveur' },
        { key: 'gerer_webhooks', label: 'modal.roles.perm_gerer_webhooks' },
        { key: 'gerer_soundboard', label: 'modal.roles.perm_gerer_soundboard' },
    ]},
    { categorie: 'modal.roles.cat_membres', perms: [
        { key: 'creer_invitation', label: 'modal.roles.perm_creer_invitation' },
        { key: 'changer_pseudo',   label: 'modal.roles.perm_changer_pseudo' },
        { key: 'gerer_pseudos',    label: 'modal.roles.perm_gerer_pseudos' },
        { key: 'expulser_membres', label: 'modal.roles.perm_expulser' },
        { key: 'bannir_membres',   label: 'modal.roles.perm_bannir' },
        { key: 'exclure_membres',  label: 'modal.roles.perm_exclure' },
    ]},
    { categorie: 'modal.roles.cat_text', perms: [
        { key: 'integrer_liens',  label: 'modal.roles.perm_integrer_liens' },
        { key: 'joindre_fichiers',label: 'modal.roles.perm_joindre_fichiers' },
        { key: 'mentionner_tous', label: 'modal.roles.perm_mentionner' },
        { key: 'gerer_messages',  label: 'modal.roles.perm_gerer_messages' },
        { key: 'epingler_messages',label:'modal.roles.perm_epingler' },
        { key: 'moderer_signalements', label: 'modal.roles.perm_moderer_signalements' },
    ]},
    { categorie: 'modal.roles.cat_vocal', perms: [
        { key: 'connecter_vocal', label: 'modal.roles.perm_connecter_vocal' },
        { key: 'parler_vocal',    label: 'modal.roles.perm_parler_vocal' },
        { key: 'partager_video',  label: 'modal.roles.perm_partager_video' },
        { key: 'rendre_muet',     label: 'modal.roles.perm_rendre_muet' },
        { key: 'mettre_sourdine', label: 'modal.roles.perm_sourdine' },
    ]},
];

export let rolesData = [];
export let membresRolesData = [];
export let roleSelectionneId = null;

export function ouvrirGestionRoles() {
    if (window.sphereSelectionneeId) {
        state.sphereSelectionneeId = window.sphereSelectionneeId;
    }

    if (!state.sphereSelectionneeId) return;
    
    const modalEdit = document.getElementById('modal-edit-sphere');
    if (modalEdit) modalEdit.style.display = 'none';
    
    document.getElementById('modal-roles').style.display = 'flex';
    roleSelectionneId = null;
    socket.emit('demander-roles-sphere', state.sphereSelectionneeId);
}

export function fermerModalRoles() {
    document.getElementById('modal-roles').style.display = 'none';
}

export function switchRolesTab(tab) {
    document.getElementById('roles-panel').style.display  = tab === 'roles'   ? 'flex' : 'none';
    document.getElementById('membres-panel').style.display = tab === 'membres' ? 'block': 'none';
    document.getElementById('tab-roles').classList.toggle('active', tab === 'roles');
    document.getElementById('tab-membres').classList.toggle('active', tab === 'membres');
}

export function afficherListeRoles() {
    const container = document.getElementById('roles-list');
    if (!container) return;
    container.innerHTML = '';
    rolesData.forEach(role => {
        const item = document.createElement('div');
        item.className = 'role-list-item' + (role.id === roleSelectionneId ? ' active' : '');
        item.onclick = () => { 
            roleSelectionneId = role.id; 
            afficherListeRoles(); 
            afficherEditeurRole(role); 
        };
        item.innerHTML = `
            <span class="role-color-dot" style="background:${role.couleur}"></span>
            <span class="role-list-name">${role.nom}</span>
        `;
        container.appendChild(item);
    });
}

export function afficherEditeurRole(role) {
    const editor = document.getElementById('roles-editor');
    if (!editor) return;
    const estProtege = role.nom === 'Administrateur' || role.nom === 'Membre';
    const permissions = role.permissions || {};

    let permsHtml = PERMISSIONS_DEF.map(cat => `
        <div class="perm-category">
            <div class="perm-category-title">${t(cat.categorie)}</div>
            ${cat.perms.map(p => `
                <label class="perm-toggle">
                    <span class="perm-label">${t(p.label)}</span>
                    <div class="toggle-switch">
                        <input type="checkbox" id="perm_${p.key}"
                            ${permissions[p.key] ? 'checked' : ''}
                            ${estProtege && role.nom === 'Administrateur' ? 'disabled' : ''}
                            onchange="window.miseAJourPermissionLocal('${p.key}', this.checked)">
                        <span class="toggle-slider"></span>
                    </div>
                </label>
            `).join('')}
        </div>
    `).join('');

    editor.innerHTML = `
        <div class="roles-editor-header">
            <div class="role-editor-name-row">
                <input type="color" id="editor-role-couleur" value="${role.couleur}"
                    ${role.nom === 'Administrateur' ? 'disabled' : ''}
                    style="width:36px; height:36px; border:none; border-radius:50%; cursor:pointer; background:none;">
                <input type="text" id="editor-role-nom" class="role-name-input" value="${role.nom}"
                    ${estProtege ? 'readonly' : ''} placeholder="Nom du rôle...">
            </div>
            ${!estProtege ? `<button class="role-delete-btn" onclick="window.supprimerRoleUI(${role.id})">
                <i class="fas fa-trash"></i>
            </button>` : ''}
        </div>
        <div class="perm-scroll">${permsHtml}</div>
        <div class="roles-editor-footer">
            ${!estProtege || role.nom === 'Membre' ? `
                <button class="cyber-btn" onclick="window.sauvegarderRole(${role.id})" style="width: 100%;">
                    <i class="fas fa-save"></i> ${t('modal.roles.save_btn')}
                </button>` : `<p style="opacity:0.5; font-size:0.8rem; text-align:center;">${t('modal.roles.admin_locked')}</p>`}
        </div>
    `;
}

export function miseAJourPermissionLocal(key, checked) {
    // Helper pour la preview en direct si besoin (vide dans ton code d'origine)
}

export function sauvegarderRole(roleId) {
    const nom = document.getElementById('editor-role-nom').value.trim();
    const couleur = document.getElementById('editor-role-couleur').value;
    if (!nom) return popToast(t('modal.roles.name_required'), 'error');

    const permissions = {};
    PERMISSIONS_DEF.forEach(cat => cat.perms.forEach(p => {
        const cb = document.getElementById(`perm_${p.key}`);
        if (cb) permissions[p.key] = cb.checked;
    }));

    socket.emit('modifier-role', {
        sphereId: state.sphereSelectionneeId,
        roleId,
        nom,
        couleur,
        permissions
    });
    popToast(t('modal.roles.saved'));
}

export function creerNouveauRole() {
    socket.emit('creer-role', {
        sphereId: state.sphereSelectionneeId,
        nom: t('modal.roles.new_role_name'),
        couleur: '#99aab5',
        permissions: { voir_salons: true }
    });
}

export function supprimerRoleUI(roleId) {
    chaosNotify(t('modal.roles.confirm_delete'), t('modal.roles.confirm_delete_title'), 'confirm').then(ok => {
        if (!ok) return;
        socket.emit('supprimer-role', { sphereId: state.sphereSelectionneeId, roleId });
        roleSelectionneId = null;
        document.getElementById('roles-editor').innerHTML = `
            <div class="roles-editor-empty">
                <i class="fas fa-shield-halved" style="font-size:2rem;opacity:0.3;"></i>
                <p>${t('modal.roles.select_hint')}</p>
            </div>`;
    });
}

export function afficherMembreRoles() {
    const container = document.getElementById('membres-roles-list');
    if (!container) return;
    container.innerHTML = '';

    membresRolesData.forEach(m => {
        const row = document.createElement('div');
        row.className = 'membre-role-row';
        row.innerHTML = `
            <div class="membre-role-identity">
                <div class="membre-role-avatar" style="background:${m.couleur}">${m.pseudo.charAt(0).toUpperCase()}</div>
                <span class="membre-role-pseudo">${m.pseudo}</span>
                ${m.role === 'admin' ? '<span class="role-crown-badge">👑</span>' : ''}
            </div>
            <select class="membre-role-select ${m.role === 'admin' ? 'disabled-select' : ''}"
                ${m.role === 'admin' ? 'disabled' : ''}
                onchange="window.assignerRoleUI('${m.pseudo}', parseInt(this.value))">
                <option value="" ${!m.role_id ? 'selected' : ''}>— ${t('modal.roles.no_role')} —</option>
                ${rolesData.filter(r => r.nom !== 'Administrateur').map(r =>
                    `<option value="${r.id}" ${m.role_id === r.id ? 'selected' : ''}>${r.nom}</option>`
                ).join('')}
            </select>
        `;
        container.appendChild(row);
    });
}

export function assignerRoleUI(pseudo, roleId) {
    socket.emit('assigner-role', {
        sphereId: state.sphereSelectionneeId,
        pseudo,
        roleId: roleId || null
    });
}

export function initRolesSync() {
    socket.on('roles-sphere', (data) => {
        rolesData = data.roles || [];
        membresRolesData = data.membres || [];
        afficherListeRoles();
        afficherMembreRoles();
        if (roleSelectionneId) {
            const r = rolesData.find(r => r.id === roleSelectionneId);
            if (r) afficherEditeurRole(r);
        }
    });

    socket.on('moderation-promotion-ok', ({ pseudo, role }) => {
        const labels = { user: t('role.user'), modo: t('role.modo'), admin: t('role.admin') };
        if (typeof popToast === 'function') popToast(t('toast.promotion_ok', { pseudo, role: labels[role] || role }), 'success');
    });
}